import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './TableRow.module.scss';

type TableRowProps = {
  className?: string;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  label: ReactNode;
  description?: ReactNode;
  testId?: string;
};

const TableRow = ({ className, leftContent, rightContent, label, description, testId }: TableRowProps) => {
  return (
    <div className={classNames(styles.container, className)} data-testid={testId}>
      {leftContent}
      <div className={styles.textContent}>
        <div className={styles.label} title={typeof label === 'string' ? label : undefined}>
          {label}
        </div>
        {description && (
          <div className={styles.description} title={typeof description === 'string' ? description : undefined}>
            {description}
          </div>
        )}
      </div>
      {rightContent}
    </div>
  );
};

export default TableRow;
